const pageSizeKey = 'pageSizeDriversKey';

export const getPageSize = (): number | undefined => {
  const size = localStorage.getItem(pageSizeKey);
  return size ? Number(size) : undefined;
};
export const setPageSize = (v: string) => {
  localStorage.setItem(pageSizeKey, v);
};
export const removePageSize = () => {
  localStorage.removeItem(pageSizeKey);
};
